/*
 * @Author: your name
 * @Date: 2020-11-09 14:51:19
 * @LastEditTime: 2020-11-16 10:11:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/product.js
 */
import request from "@/utils/request";
// 分类列表总数据
export async function queryCategories(params) {
  const url = "/api/front/product/retailReceptionCategory/queryCategories";
  return request(url, { params });
}
// 搜索页面搜索结果
export async function findClientRetailSpuByParam(params) {
  const url = `/api/front/retailSpu/findClientRetailSpuByParam`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 搜索页面搜索发现
export async function searchFoundList() {
  const url = `/api/front/retailSpu/searchFoundList`;
  return request(url);
}
// 商品详情
export async function mallretailspu(params) {
  const url = `/api/front/product/retailSpu/mallretailspu/${params.spuId}?slug=${params.slug}`;
  return request(url);
}
// 品牌馆
export async function queryBrandById(params) {
  const url = `/api/front/product/brand/queryBrandById/${params.id}`;
  return request(url);
}
